import React, { useRef, useEffect, useState } from 'react';
import './HorizontalScrollCards.css';

const HorizontalScrollCards = () => {
  const containerRef = useRef(null);
  const [selectedPopup, setSelectedPopup] = useState(null);

  const handleCardClick = (cardTitle) => {
    if (cardTitle === 'Sector Rotation') {
      setSelectedPopup('sector_rotation');
    } else if (cardTitle === 'Index Mover') {
      setSelectedPopup('index_mover');
    } else if (cardTitle === 'OI Monitor') {
      setSelectedPopup('oi_monitor');
    }
  };

  const closePopup = (e) => {
    if (e.target.className === 'popup-overlay' || e.target.className === 'popup-close-btn') {
      setSelectedPopup(null);
    }
  };

  const cards = [
    {
      id: 1,
      image: '/images/HEATMAP.png',
      company: 'Heatmap',
      location: 'Live Market',
      description: 'A clear map of winners and losers, instantly visualize market trends.',
      stats: ['Real-time Data', 'Sector Analysis']
    },
    {
      id: 2,
      image: '/images/Sector_Rotation.jpeg',
      company: 'Sector Rotation',
      location: 'Market Trends',
      badge: 'NEW',
      description: 'Track capital flow across different market sectors and identify emerging trends.',
      stats: ['Sector Analysis', 'Trend Tracking']
    },
    {
      id: 3,
      image: '/images/index mover.png',
      company: 'Index Mover',
      location: 'Market Breadth',
      description: 'Track the heavyweight stocks pulling or pushing the main indices. Know exactly what dictates market direction.',
      stats: ['Index Contribution', 'Real-time Pulse']
    },
    {
      id: 4,
      image: '/images/OI Monitor 3.png',
      company: 'OI Monitor',
      location: 'Derivatives Data',
      badge: 'PRO',
      description: 'Monitor Open Interest build-ups and unwinding. Decode options data to pinpoint hidden support and resistance levels.',
      stats: ['Options Analytics', 'OI Shifts']
    }
  ];

  return (
    <div className="horizontal-scroll-section">
      <div className="scroll-container-wrapper" ref={containerRef}>
        <div className="scroll-track">
          {[...cards, ...cards].map((card, index) => (
            <div 
              key={`${card.id}-${index}`} 
              className={`scroll-card ${['Sector Rotation', 'Index Mover', 'OI Monitor'].includes(card.company) ? 'clickable-card' : ''}`}
              onClick={() => handleCardClick(card.company)}
            >
              <div className="card-image-wrapper">
                <img src={card.image} alt={card.company} className="card-image" />
                <div className="image-overlay"></div>
              </div>
              <div className="card-content">
                <div className="card-location">
                  {card.location}
                </div>
                <h3 className="card-company">
                  {card.company}
                  {card.badge && <span className="card-badge">{card.badge}</span>}
                </h3>
                <p className="card-description">{card.description}</p>
                <div className="card-stats">
                  {card.stats.map((stat, index) => (
                    <span key={index} className="stat-pill">{stat}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {selectedPopup === 'sector_rotation' && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content">
            <button className="popup-close-btn" onClick={closePopup}>×</button>
            <h2 className="popup-heading">Sector Rotation</h2>
            <div className="popup-text">
              <p>Markets don't move stock by stock — they move Sector by Sector.</p>
              <p>Our AI-powered Sector Rotation engine tracks money flow across sectors in real time, revealing which industries are gaining strength and which are losing momentum.</p>
              <p>Trade where the strength is. Exit where the weakness begins.</p>
            </div>
          </div>
        </div>
      )}

      {selectedPopup === 'index_mover' && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content">
            <button className="popup-close-btn" onClick={closePopup}>×</button>
            <h2 className="popup-heading">Index Mover</h2>
            <div className="popup-text">
              <p>AI-powered insights that reveal the true stocks moving the Index.</p>
              <p>Our AI decodes market momentum at its source.</p>
              <p>So you trade with precision, not prediction.</p>
            </div>
          </div>
        </div>
      )}

      {selectedPopup === 'oi_monitor' && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content">
            <button className="popup-close-btn" onClick={closePopup}>×</button>
            <h2 className="popup-heading">OI Monitor</h2>
            <div className="popup-text">
              <p>OI Monitor reveals where the smart money is building positions. From long buildups to short covering – stay one step ahead of market shifts.</p>
              <br/>
              <p>📊 Trade Like Professional Traders</p>
              <p>💡 Powerful Trade Ideas</p>
              <p>🧠 10+ Trading Strategies</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HorizontalScrollCards;
